import { defineMessage } from 'react-intl';

/** Section titles for the admin fragments config forms. */
export const fragmentsManageMessages = {
  registeredFootersTitle: defineMessage({
    id: 'admin.fragments.registeredFootersTitle',
    defaultMessage: 'Footers registrados',
  }),
  newFooterName: defineMessage({
    id: 'admin.fragments.newFooterName',
    defaultMessage: 'Nuevo footer',
  }),
  watermarkImageTitle: defineMessage({
    id: 'admin.fragments.watermark.imageTitle',
    defaultMessage: 'Imagen',
  }),
  watermarkPositionTitle: defineMessage({
    id: 'admin.fragments.watermark.positionTitle',
    defaultMessage: 'Posición',
  }),
  tagGroupsTitle: defineMessage({
    id: 'admin.fragments.tagGroups',
    defaultMessage: 'Grupos de tags',
  }),
};
